import Dialog from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import noop from '@anm/helpers/noop';
import { AlertText } from '@anm/styles/helpers';
import { useCallback, useMemo, useState, FC } from 'react';

export type EditBigVideoAlertProps = {
  onClose?(): void;
};

const EditBigVideoAlert: FC<EditBigVideoAlertProps> = ({ onClose = noop }) => (
  <Dialog onModalClose={onClose}>
    <AlertBlock onButtonClick={onClose}>
      <AlertText>
        While you can host videos of any length with us, Wave.video does not
        support editing videos longer than 1 hours.
      </AlertText>
    </AlertBlock>
  </Dialog>
);

export const useEditBigVideoAlert = () => {
  const [isEditBigVideoAlert, setEditBigVideoAlert] = useState(false);
  const closeAlert = useCallback(() => setEditBigVideoAlert(false), []);

  const renderAlert = useMemo(
    () => (
      <>{isEditBigVideoAlert && <EditBigVideoAlert onClose={closeAlert} />}</>
    ),
    [isEditBigVideoAlert]
  );

  return [renderAlert, setEditBigVideoAlert] as const;
};
export default EditBigVideoAlert;
